export default {
  SET_LOADING(state, loading){
    state.loading = loading
  },
  SET_LOADING_MENTORY_USER(state, loadingMentoryUser){
    state.loadingMentoryUser = loadingMentoryUser
  },
  SET_MENTORY_USER(state, mentoryUser){
    state.mentoryUser = mentoryUser
  },
};
